import React from "react";
import "./carousel.css";
import airbnbLogoImg from "../../images/Airbnb-Logo.svg";
import bookingLogoImg from "../../images/Booking.com-Logo.svg";
import expediaLogoImg from "../../images/Expedia-Logo.svg";
import homeAwayLogoImg from "../../images/homeaway-logo.png";
import tripAdvisorLogoImg from "../../images/TripAdvisor_Logo.svg";

const CarouselSection = () => {
  return (
    <section id="carousel">
      <div className="carousel-wrapper">
        <div className="logo-carousel-fader">
          <div className="logo-carousel">
            <div className="logo-track">
              <img src={expediaLogoImg} alt="Expedia" />
              <img src={homeAwayLogoImg} alt="HomeAway" />
              <img src={airbnbLogoImg} alt="Airbnb" />
              <img src={tripAdvisorLogoImg} alt="Tripadvisor" />
              <img
                src={bookingLogoImg}
                alt="Booking.com"
                className="booking-img"
              />

              {/* duplicate for smooth loop */}
              <img src={expediaLogoImg} alt="Expedia" />
              <img src={homeAwayLogoImg} alt="HomeAway" />
              <img src={airbnbLogoImg} alt="Airbnb" />
              <img src={tripAdvisorLogoImg} alt="Tripadvisor" />
              <img
                src={bookingLogoImg}
                alt="Booking.com"
                className="booking-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarouselSection;
